import { type VariantProps, cva } from "class-variance-authority";
import { type ElementType, type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const textVariants = cva("", {
	variants: {
		size: {
			xs: "text-xs",
			sm: "text-sm",
			md: "text-base",
			lg: "text-lg",
			xl: "text-xl",
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
			bold: "font-bold",
		},
		textColor: {
			foreground: "text-foreground",
			mutedForeground: "text-mutedForeground",
			destructive: "text-destructive",
			primary: "text-primary",
			secondary: "text-secondaryForeground",
		},
	},
	defaultVariants: {
		size: "md",
		weight: "normal",
		textColor: "foreground",
	},
});

export interface TextProps
	extends Omit<HTMLAttributes<HTMLElement>, "color">,
		VariantProps<typeof textVariants> {
	as?: ElementType;
}

const Text = forwardRef<HTMLElement, TextProps>(
	({ className, as: Tag = "p", size, weight, textColor, ...props }, ref) => (
		<Tag
			ref={ref}
			className={cn(textVariants({ size, weight, textColor }), className)}
			{...props}
		/>
	),
);
Text.displayName = "Text";

export default Text;
export { Text };
